module.exports = __webpack_public_path__ + "img/Feature.e43c5c9a.png";